import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useToast } from '@/components/ui'
import { usersService } from '@/services/http/usersService'

export type UsersByAreasItem = {
  value: string
  label: string
  avatar: string | null
  area: string | null
}

type UseUsersByAreasParams = {
  areaIds?: string[]
}

type UseUsersByAreasResponse = {
  users: UsersByAreasItem[]
  isLoading: boolean
  refetch: () => void
}

export function useUsersByAreas(
  params: UseUsersByAreasParams = {},
): UseUsersByAreasResponse {
  const { areaIds } = params
  const { toast } = useToast()

  const { data, isError, isLoading, refetch } = useQuery({
    queryKey: ['usersByAreas', areaIds ?? []],
    queryFn: () => usersService.listUsersByAreas({ areaIds }),
  })

  useEffect(() => {
    if (isError)
      toast({
        title: 'Erro ao carregar usuários',
        variant: 'destructive',
      })
  }, [isError, toast])

  if (data) {
    return {
      users: data,
      isLoading,
      refetch,
    }
  }

  return {
    users: [],
    isLoading,
    refetch,
  }
}
